// src/components/Header.jsx
import React from "react";
import logo from "../logo.png";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { i18n, t } = useTranslation();

  const handleChange = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <header className="sticky top-0 z-40 border-b border-blue-100 bg-white/95 backdrop-blur shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 py-2.5">
        {/* Logo */}
        <a href="https://ara.ro" className="shrink-0">
          <img src={logo} alt="ARA Logo" className="h-14 sm:h-20" />
        </a>

        {/* Meniu + limbă */}
        <div className="flex items-center gap-4 sm:gap-6">
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-[#003B5C]">
            <a href="https://ara.ro/sp/despre-ara" className="transition hover:text-[#0066A6]">
              {t("despre")}
            </a>
            <a href="https://ara.ro/sp/evenimente-comunicare" className="transition hover:text-[#0066A6]">
              {t("evenimente")}
            </a>
            <a href="https://ara.ro/sp/contact" className="transition hover:text-[#0066A6]">
              {t("contact")}
            </a>
          </nav>

          <select
            onChange={handleChange}
            value={i18n.language}
            className="rounded-lg border border-gray-200 bg-white px-2 py-1.5 text-sm text-[#003B5C] shadow-sm transition focus:border-[#0066A6] focus:outline-none focus:ring-2 focus:ring-[#0066A6]/20"
          >
            <option value="ro">🇷🇴 {t("romana")}</option>
            <option value="en">🇬🇧 {t("english")}</option>
          </select>
        </div>
      </div>
    </header>
  );
};

export default Header;
